function toggleTooltip(element) {
    var parent = element.closest('.tooltip-parent');
    if (!parent) return; 
    var position = parent.getBoundingClientRect().top;
    var tooltip = parent.querySelector('.tooltip');

    var allTooltips = document.querySelectorAll('.tooltip');
    allTooltips.forEach(function(item) {
        item.style.display = 'none';
    });

    if (position >= window.innerHeight / 2) {
        tooltip.classList.remove("tooltipTop");
        tooltip.classList.add("tooltipBottom");
        element.classList.remove("anchor-top");
        element.classList.add("anchor-bottom");
    } else {
        tooltip.classList.remove("tooltipBottom");
        tooltip.classList.add("tooltipTop");
        element.classList.add("anchor-top");
        element.classList.remove("anchor-bottom");
    }

    tooltip.style.display = 'block';

    tooltip.addEventListener('mouseout', function(e) {
        hideTooltip(element);
    });
}

function hideTooltip(element) {
    var parent = findTooltipParent(element);
    if (!parent) return;

    var tooltip = parent.querySelector('.tooltip');
    if (!tooltip) return;

    tooltip.style.display = 'none';
    element.classList.remove("anchor-top", "anchor-bottom");
}

function findTooltipParent(element) {
    var parent = element.parentNode;
    while (parent) {
        if (parent.classList.contains('tooltip-parent')) {
            return parent;
        }
        parent = parent.parentNode;
    }
    return null;
}

 function showTooltip(element) {
      var parent = element.closest('.tooltip-parent');
      if (!parent) return; 
      var tooltip = parent.querySelector('.tooltip');
      tooltip.style.display = 'block';

      var position = parent.getBoundingClientRect().top;

      if (position >= window.innerHeight / 2) {
          tooltip.classList.remove("tooltipTop");
          tooltip.classList.add("tooltipBottom");
          element.classList.remove("anchor-top");
          element.classList.add("anchor-bottom");
      } else {
          tooltip.classList.remove("tooltipBottom");
          tooltip.classList.add("tooltipTop");
          element.classList.add("anchor-top");
          element.classList.remove("anchor-bottom");
      }
  }

  function hideTooltipNew(element) {
      var parent = element.closest('.tooltip-parent');
      if (!parent) return;
      var tooltip = parent.querySelector('.tooltip');
      tooltip.style.display = 'none';
      element.classList.remove("anchor-top", "anchor-bottom");
  }



document.addEventListener("DOMContentLoaded", function () {
  const review_section_links = document.querySelectorAll(
    ".product__info-wrapper .review_section_link"
  );

  review_section_links.forEach((eachButton) => {
    eachButton.addEventListener("click", (event) => {
      const href = eachButton.getAttribute("href");

      if (!href || href === "javascript:void(0)" || href === "#") {
        event.preventDefault(); 
        return; 
      }

      event.preventDefault(); 

      const navigationSection = document.querySelector(href);

      if (navigationSection) {
        const sectionOffsetTop = navigationSection.offsetTop;

        window.scrollTo({
          top: sectionOffsetTop - 200, 
          behavior: "smooth",
        });
      }
    });
  });
});















